var borderRadiusMedium = 4;
var borderRadiusLarge = 6;
var borderRadiusXLarge = 8;
export { borderRadiusLarge, borderRadiusMedium, borderRadiusXLarge };